export { default } from './layout.vue'


// WEBPACK FOOTER //
// ./example/components/layout/index.js